import { withViewComponent } from '@updater-local/custom-element-v1';
import '@updater-legacy/components/date-formatter';
import '../../star';
import styles from './index.css';

class Reviews extends withViewComponent(styles)() {
  static props = ['value'];

  updated({ value }) {
    this.render`
      ${value.map(
        (entry) => `
          <div class="entry">
            <div class="name-and-date">
              <div>${entry.name}</div>
              <upd-date-formatter
                format="UTC:mmmm, yyyy"
                value="${entry.date}"
              >
              </upd-date-formatter>
            </div>
            <upd-moveiq-star value=${entry.rating}></upd-moveiq-star>
            <div>${entry.review}</div>
          </div>
        `
      )}
    `;
  }
}

customElements.define('upd-moveiq-company-reviews', Reviews);
